import ".././styles/Donate.css";
import ControlledPopup from "../components/Popup.js";
import React, { useState, useEffect } from "react";
import { HashLink as Link } from 'react-router-hash-link';

function Donate() {

    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupDescription, setPopupDescription] = useState("");
    const [popupLink, setPopupLink] = useState("");
    const [popupLinkName, setPopupLinkName] = useState("");

    const openPopup = (popUpNumber) => {
        if (popUpNumber === 1) {
            setPopupTitle("Donate In-Person");
            setPopupDescription(
                "In our office, we do not accept cash due to our No Cash Policy. However, we accept Interac, Credit Cards, Cheque, and E-transfer to thenewpccm@gmail.com."
            );
            setPopupLink(null);
            setPopupLinkName(null);
        } 
        else if (popUpNumber === 2) {
            setPopupTitle("Donate Using E-transfer");
            setPopupDescription(
                "Please e-transfer to thenewpccm@gmail.com and include the reason for your payment, and since we cannot obtain your email through e-transfer, kindly include your email under the e-transfer memo so we can provide you with the receipt."
            );
            setPopupLink(null);
            setPopupLinkName(null);
        }
        else if (popUpNumber === 3){
            setPopupTitle("Donate via CanadaHelps");
            setPopupDescription(
                "CanadaHelps is charity organization that support over 85,000 Canadian registered charities via digital donations. Donors can easily track donations and get instant tax receipts – all for free in your CanadaHelps account."
            );
            setPopupLink("https://www.canadahelps.org/en/charities/the-philippine-canadian-centre-of-manitoba-incorporated/");
            setPopupLinkName("Visit");
        }
        setPopupOpen(true);
    };

    const closePopup = () => setPopupOpen(false);

    return (
        <>
            <ControlledPopup
                open={isPopupOpen}
                onClose={closePopup}
                title={popupTitle}
                description={popupDescription}
                linkName={popupLinkName}
                link={popupLink}
            />
            <div className="container">
                <div className="donation-banner-container" id="banner">
                    <div className="donation-banner">
                        <h1>Donate</h1>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sub-container">
                    <div className="donation-section" id="donation-info">
                        <h2 className="section-title">Supporting PCCM</h2>
                        <p>
                            We invite individuals, corporations, foundations, and benefactors to support the Philippine-Canadian Centre of Manitoba. 
                            Your grants and donations are vital to enhancing Filipino-Canadian heritage and maintaining our centre as a thriving hub 
                            for social, cultural, and educational events in Winnipeg and Manitoba. With your help, we can improve and renovate our facility and host 
                            more community events. Every contribution, no matter how small, is deeply valued and makes a positive difference in our community.
                        </p>
                        <p className="italic">
                           For more information regarding funds to further certain initiative or an alternative way to donate, please contact 
                           us at thenewpccm@gmail.com or at (204) 775-4928.
                        </p>
                    </div>
                </div>
            </div>
            <div className="container" id="donation-categories-section">
                <div className="sub-container donation-form">
                    <iframe id="donation-fields"src="https://forms.fillout.com/t/uQqaXuyLi2us"  width="1200" height="800" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </div>
                <div className="sub-container options">
                    <h4>Other Ways to Donate</h4>
                    <div className="option-buttons alternative-donation">
                        <div onClick={() => openPopup(1)} className="button-2">
                            <b>In-Person</b>
                        </div>
                        <div onClick={() => openPopup(2)} className="button-2">
                            <b>E-transfer</b>
                        </div>
                        <div onClick={() => openPopup(3)} className="button-2">
                            <b>CanadaHelps</b>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sub-container">
                    <div className="donation-section" id="donation-info">
                        <h2 className="section-title">Accountability and Transparency</h2>
                        <p>
                            We truly understand how much you care about ensuring that your donation is used effectively. Your trust means everything to us, and we share your 
                            commitment to making a meaningful impact. That’s why we strive to maintain accountability and transparency in our finances, so you can feel confident 
                            that your support is making a real difference.
                        </p>
                        <div className="option-buttons">
                            <Link to="/constitution#top" className="button-1 button-shadow">
                                Our Constitution
                            </Link>
                            <Link to="/report#top" className="button-1 button-shadow">
                                Finance & Report
                            </Link>
                        </div>
                    </div>
                </div>
            </div>            
        </>
    );
}

export default Donate;